import { object, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import objectEditorEnhancer from 'coact/objectEditorEnhancer'

import LensSpecView from './LensSpec'

const LensSpec = scope(
  consumeProps({
    value: object,
    onChange: func.isRequired,
  }),

  objectEditorEnhancer,

  exposeProps([
    'value',
    'onChange',
    'spliter',
  ]),
)(LensSpecView)

LensSpec.displayName = 'LensSpec'

export default LensSpec



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/ItemsEditor/ItemEditor/LensSpec/index.js